// basic config
export const containerSelector = "#warehouse";
export const loginContainerSelector = "#loginContainer";
export const footerSelector = "#warehouseFooter";
export const urlParamPrefix = "tx_igwarehouse_warehouse";
export const ajaxPageNum = 3500;
export const defaultLocale = 'de-DE';

// design constants
export const advancedSearchAutoHideWindowWidth = 1024;

// program logic constants
export const defaultThickness = 0.6;

// timings
export const debounceAjaxOnInput = 500;

// animation timings
export const snackbarDisplayTime = 5000;

// pagination
export const logSearchPageSize = 60;
export const watchlistSearchPageSize = 10;
export const measurementListPageSize = 0;

// watchlist settings
export const defaultShareValidityDays = 28;

// bundle viewer
export const maxScale = 6;
export const scalaSettings = {
	width: 30,
	padding: 40,
	scalaFillStyle: '#ffffff',
	fillStyle: '#000000',
	strokeStyle: '#000000',
	fontFamily: 'sans-serif',
	fontSize: 12,
	textAlign: 'right',
	textOffset: {
		x: -10,
		y: -1
	},
	axisStep: 5,

	big: {
		showLabel: true,
		width: 10,
		height: 2
	},

	small: {
		showLabel: false,
		width: 5,
		height: 2
	}
};

export const snackLevelColors = {
	0: 'primary',
	1: 'info',
	2: 'negative'
};